import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  actions: {
    fetchDispatchConfigurations() {
      return axiosIns.get('dispatch/dispatch-configurations')
    },
    createDispatchConfig(_, data) {
      return axiosIns.post('/dispatch/dispatch-configurations', data)
    },
    editDispatchConfig(_, { data, id }) {
      return axiosIns.patch(`/dispatch/dispatch-configurations/${id}`, data)
    },
    getDispatchConfig(_, id) {
      return axiosIns.get(`/dispatch/dispatch-configurations/${id}`)
    },
  },
}
